/**
 * `router/downloadForm.js`
 *  - 資料ダウンロード申し込みフォームページ用スクリプト
 *    URL: /download/form/?post_id=xxx (子ページ slug=form / 親 download)
 *    namespace は親子構造の leaf を採用するため "form" になる
 *
 * 使用方法:
 *  - /router/index.js initRouterで動的読み込み
 *  - import {downloadFormRouter} from "./router/downloadForm.js";
 */


import {initMwWpForm} from "../core/wordpress/mwwpform/mwwpform.js";
import {initForm} from "../modules/form.js";


export const downloadFormRouter = (data) => {
  console.log("📖 Initializing download form page...");

  initMwWpForm(data);
  initForm();
}
